import 'css-chunksrc/client/scenes/wbs/milestone/nameEditionForm/styles.scss';export default {
  "nameEditionForm": "_nameEditionForm_76ze4_1",
  "form": "_form_76ze4_6",
  "hovered": "_hovered_76ze4_10",
  "name": "_name_76ze4_1",
  "icon": "_icon_76ze4_32",
  "input": "_input_76ze4_36",
  "edition": "_edition_76ze4_57",
  "tooltip": "_tooltip_76ze4_64"
};